import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EmptyHeader from '../Shared/EmptyHeader';
import { useAuth } from "../../src/Context/AuthContext"

const RegistrationEmailSection = ({ portalSettings }) => {
    //State Variables
    const [agtCode, setAgtCode] = useState('');
    const [polNo, setPolNo] = useState('');
    const navigate = useNavigate();
    const { logout } = useAuth();
    const psm = portalSettings; 

    //ENV Variables
    const apiURL = import.meta.env.VITE_API;
   
    const SendAgentRegEmail = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${apiURL}/admin/SendAgtRegEmail/?AgtCode=${agtCode}`, {
                method: "POST",
                credentials: "include"
            });

            if (res.status === 401) {
                logout();
                navigate('/login');
                throw new Error("unauthorized");
            }

            if (res.status === 403) {
                navigate('/home');
                throw new Error("forbidden");
            }

            if (!res.ok) {
                const text = await res.text(); // log raw error response
                throw new Error(`Request failed: ${res.status} ${res.statusText}\n${text}`);
            }

            alert("Registration Email sucessfully sent.")
        } catch (err) {
            console.error('Error fetching by name:', err);
            alert("An error occurred while fetching data. Check the console for details.");
        }
    };

    const SendPolNoRegEmail = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${apiURL}/admin/SendPolNoRegEmail/?PolNo=${polNo}`, {
                method: "POST",
                credentials: "include"
            });

            if (res.status === 401) {
                logout();
                navigate('/login');
                throw new Error("unauthorized");
            }

            if (res.status === 403) {
                navigate('/home');
                throw new Error("forbidden");
            }

            if (!res.ok) {
                const text = await res.text(); // log raw error response
                throw new Error(`Request failed: ${res.status} ${res.statusText}\n${text}`);
            }

            alert("Registration Email sucessfully sent.")
        } catch (err) {
            console.error('Error fetching by name:', err);
            alert("An error occurred while fetching data. Check the console for details.");
        }
    };

    return (
        <div className="admin-search-page" id="email-send-container">

            <div className="admin-search-columns">

                {psm.hasAgentPortal && (
                    <div className="search-card">
                        <h5>Send Agent Registration Email</h5>
                        <form className="baseForm" onSubmit={SendAgentRegEmail}>
                            <label className="baseLabel">Agent Code</label>
                            <input
                                type="text"
                                value={agtCode}
                                className="baseInput"
                                onChange={(e) => setAgtCode(e.target.value)}
                                placeholder="e.g. 00001"
                                required
                            />
                            <button type="submit" className="baseButton">Send</button>
                        </form>
                    </div>
                )}

                {psm.hasPolicyPortal && (
                    <div className="search-card">
                        <h5>Send PolicyHolder Registration Email</h5>
                        <form className="baseForm" onSubmit={SendPolNoRegEmail}>
                            <label className="baseLabel">Policy Number</label>
                            <input
                                type="text"
                                value={polNo}
                                className="baseInput"
                                onChange={(e) => setPolNo(e.target.value)}
                                placeholder="e.g. 0000000001"
                                max length="10"
                                required
                            />
                            <button type="submit" className="baseButton">Send</button>
                        </form>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RegistrationEmailSection;
